import React, { useState, useEffect, useContext } from "react";
import CommonBreadCrumb from "../componets/CommonBreadCrumb";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {AiFillCheckCircle} from "react-icons/ai"
import { NavLink, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import call_apis from "../services/Apis";
import { GlobalCart } from "../App";
import { useLocation } from "react-router-dom";
import { pushToDataLayer,getUserId } from "../utils/datalayerPush";

const ThanksOrder = () => {
  const { t } = useTranslation();
  const data = [{ slug: "Order Confirmation", link: "", url: "" }];
  const {slug} = useParams()
  let navigate = useNavigate();
  const [seconds, setSeconds] = useState(4);
  const cookies = new Cookies();
  const { cartList } = useContext(GlobalCart);
  const location = useLocation();
  const removeItems = async () => {
    if (cookies.get("jwt_token") !== undefined) {
      const resp = await call_apis.updateCartStatus();
      if (resp.status === 200) {
       
      }
    }

  };

  useEffect(() => {
    cookies.remove("oscad");
    removeItems();
    const timerId = setTimeout(() => {
      // navigate("/my-orders");
    }, 4000); // 4000 milliseconds = 4 seconds
    return () => clearTimeout(timerId);
  }, []);

  useEffect(() => {
    if (seconds > 0) {
      setTimeout(() => setSeconds(seconds - 1), 1000);
    } else {
      setSeconds("BOOOOM!");
    }
  }, []);


  if(Object.keys(cartList).length > 0){
    //Adding google data layer
    window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    window.dataLayer.push({
      event: "purchase",
      ecommerce: {
        currency: "QAR",
        value: cartList.grand_total,
        items: cartList.result.map((each, id) => ({
          
          item_id: '"'+ each.sku + '"',
          item_name: '"'+ each.name + '"',
          index: id,
          item_brand: '"'+ each.brand + '"',
          item_category: '"'+ each.category_name+'"',
          item_category2: '"'+ each.subcategory_name+'"',
          item_category3: '"'+ each.sub_sub_category_name+'"',
          price: each.single_price,
          quantity: each.quantity
        }))
      }
    });
    // Adding Facebook Purchase Event
    if (window.fbq) {
      console.log("Facebook Purchase Event Triggered");
      pushToDataLayer("purchase_made", {
        value: cartList.grand_total,
        currency: "QAR",
      },
      false
    );
      window.fbq("track", "Purchase", {
          value: cartList.grand_total,
          currency: "QAR",
      }, { 
          eventID: "purchase_" + new Date().getTime() // Generates a unique event ID
      });
      } else {
          console.warn("Facebook Pixel (fbq) is not initialized!");
      }
  }
  useEffect(() => {
    if (location.pathname.includes("/order/thanks/")) {
      let storedCart = localStorage.getItem("order_data");
      let finalCartData = cartList;
  
      if (!cartList || Object.keys(cartList).length === 0) {
        if (storedCart) {
          finalCartData = JSON.parse(storedCart);
        } else {
          console.error("No cart data found for order_placed event!");
          return;
        }
      }
  
      // Log the finalCartData to confirm the most up-to-date data
      console.log("Final Cart Data:", finalCartData);
  
      // Push order_placed event
      window.dataLayer.push({
        event: "order_placed",
        user_id: getUserId() || "guest",
        ecommerce: {
          currency: "QAR",
          value: finalCartData.grand_total, // Correct order total
          transaction_id: finalCartData.order_id, // Ensure order_id is not undefined
          items: finalCartData.result.map((each, id) => ({
            item_id: each.sku,
            item_name: each.name,
            index: id,
            price: each.single_price,
            quantity: each.quantity,
          })),
        },
      });
      pushToDataLayer("order_placed",{
        event: "order_placed",
        user_id: getUserId() || "guest",
        ecommerce: {
          currency: "QAR",
          value: finalCartData.grand_total, // Correct order total
          transaction_id: finalCartData.order_id, // Ensure order_id is not undefined
          items: finalCartData.result.map((each, id) => ({
            item_id: each.sku,
            item_name: each.name,
            index: id,
            price: each.single_price,
            quantity: each.quantity,
          })),
        },
      },false) 
      console.log("`order_placed` event pushed to GTM with updated data:", finalCartData);
    }
  }, [location.pathname]);

  return (
    <Container
      fluid
      className="maxWidthContainerFluid paddingContainerFluid ThanksOrder"
    >
      <Container fluid className="maxWidthContainerFluid">
        <CommonBreadCrumb data={data} />
      </Container>
      <Container className='mb-3'>
      <Row>
        <Col md={7} className="text-center thanksContainer">
          <div className="head">{t("thanks.order")}</div>
           <AiFillCheckCircle size={40} color="#7ec900" className="tick" />
          <div className="text">{t("your.order")}</div>
          <div className="thanksInput text2">
            {t("your.orderis")} {slug}
          </div>
          <div className="text2">{t("thaks.text")}</div>
          <div className="text2 mb-4">{t("thaks.sec")}</div>
          <div className="ProductDetail thankbutton">
            <NavLink to="/" className="productAddToCart">
              {t("continue.shopping")}
            </NavLink>
          </div>
          <div className="redirect">
            {t("thanks.redirect")} {seconds} {t("thanks.seconds")}
          </div>
        </Col>
        <Col md={1}></Col>
        <Col md={4} className="text-center thanksContainer">
          <div className="head">{t("track.order")}</div>
          <div className="thanksInput text2">{slug}</div>
          <div className="ProductDetail thankbutton">
            <button type="button" className="productAddToCart" style={{padding: "8px 7px"}}>
              {t("search.status")}
            </button>
          </div>
        </Col>
      </Row>
      </Container>
    </Container>
  );
};

export default ThanksOrder;
